import styles from './DataList.module.scss';

type DataListAllowedChildren = React.ReactElement<React.ComponentProps<typeof DataListItem>>;

interface DataListProps {
  children:
    | DataListAllowedChildren
    | DataListAllowedChildren[]
    | (DataListAllowedChildren | DataListAllowedChildren[])[];
}

export const DataList = ({ children }: DataListProps) => (
  <dl className={styles.list}>{children}</dl>
);

interface DataListItemProps {
  label: string;
  value: string;
}

export const DataListItem = ({ label, value }: DataListItemProps) => (
  <>
    <dt className={styles.label}>{label}</dt>
    <dd className={styles.value}>{value}</dd>
  </>
);
